import React, { FC } from 'react'
import { GridColDef } from '@mui/x-data-grid-premium'
import { SensorColumnsDataGrid } from 'src/components/columns/sensor'
import { Sensor, SensorState } from 'src/api'
import { SensorListFilters, SensorsMapView } from 'src/components'
import { SearchParamsKeys, ViewTypes, SensorFilters, SensorButtons } from 'src/enums'
import { useQueryParamsState } from 'src/hooks/ui'
import { CommonSensorList } from './commonSensorsList'
import { ContractorsDataLoader } from './contractorsDataLoader'
import { SensorContextMenu, SensorMenuItemKey, useSensorContextMenu, createActionsColumn } from './sensorContextMenu'
import { SensorMapFilters } from '../../../forms/sensor/sensorMapFilters'

interface AssignedSensorListProps {
  isLoading: boolean
  count: number
  data: Sensor[]
  states: SensorState[]
  refetchSensorList: () => void
}

export const AssignedSensorList: FC<AssignedSensorListProps> = ({ data, isLoading, count, states, refetchSensorList }) => {
  const { currentRow, menuAnchorEl, handleOpenMenu, handleCloseMenu } = useSensorContextMenu()
  const queryParams = useQueryParamsState()
  const viewType = queryParams[SearchParamsKeys.ViewType] || ViewTypes.List

  const columns: GridColDef<Sensor>[] = [
    SensorColumnsDataGrid.Id(),
    SensorColumnsDataGrid.Model,
    SensorColumnsDataGrid.IMEI,
    SensorColumnsDataGrid.DevEUI,
    SensorColumnsDataGrid.LastActiveContractor,
    SensorColumnsDataGrid.LastPing,
    SensorColumnsDataGrid.BatteryLevel,
    SensorColumnsDataGrid.DateAssigned,
    SensorColumnsDataGrid.StateUpdatedAt,
    SensorColumnsDataGrid.StateAuthor,
    SensorColumnsDataGrid.OrderDate,
    SensorColumnsDataGrid.OrderNumber,
    SensorColumnsDataGrid.OrderPart,
    createActionsColumn(handleOpenMenu)
  ]

  return (
    <>
      {viewType === ViewTypes.List ? (
        <>
          <CommonSensorList
            columns={columns}
            count={count}
            data={data}
            isLoading={isLoading}
            filters={
              <ContractorsDataLoader>
                <SensorListFilters
                  activeFilters={[
                    SensorFilters.LowBattery,
                    SensorFilters.WeakSignal,
                    SensorFilters.LastPingMoreThanHour,
                    SensorFilters.SyncPeriod,
                    SensorFilters.ReadingsAge,
                    SensorFilters.CurrentSensorConfiguration,
                    SensorFilters.BleStatus,
                    SensorFilters.Contractor,
                    SensorFilters.OrderNumber,
                    SensorFilters.OrderDate
                  ]}
                />
              </ContractorsDataLoader>
            }
            buttons={[SensorButtons.QualityControl, SensorButtons.DownloadLabels, SensorButtons.GetHistoricalData, SensorButtons.ManageSensorBleState]}
            checkboxSelection
          />
          <SensorContextMenu
            menuItems={[SensorMenuItemKey.Reassign, SensorMenuItemKey.MarkAsLost]}
            qualityControlBeforeAssign
            currentRow={currentRow}
            menuAnchorEl={menuAnchorEl}
            onOpenMenu={handleOpenMenu}
            onCloseMenu={handleCloseMenu}
            states={states}
            refetchSensorList={refetchSensorList}
          />
        </>
      ) : (
        <SensorsMapView
          data={data}
          isLoading={isLoading}
          filters={
            <ContractorsDataLoader>
              <SensorMapFilters
                activeFilters={[
                  SensorFilters.Contractor,
                  SensorFilters.LowBattery,
                  SensorFilters.WeakSignal,
                  SensorFilters.LastPingMoreThanHour,
                  SensorFilters.SyncPeriod,
                  SensorFilters.ReadingsAge,
                  SensorFilters.LocationType,
                  SensorFilters.OrderNumber,
                  SensorFilters.OrderDate
                ]}
              />
            </ContractorsDataLoader>
          }
        />
      )}
    </>
  )
}
